import React from 'react';

import UserFilter from 'components/Filters/UserFilter';

import { Filter } from '@gogame/filters';

import {
  FILTER_ADDED,
  FILTER_PERIOD,
  FILTER_ACTIONS_TYPE,
  FILTER_APPLICATIONS,
  FILTER_APPROVERS,
  FILTER_BUSINESS_PARTNERS,
  FILTER_AFFILIATES,
  FILTER_CUSTOMER_COMPANIES,
  FILTER_CREATED_BY,
  FILTER_EXPENSE_TYPES,
  FILTER_IMPORTANCE,
  FILTER_STATUSES,
} from 'scenes/FinancialResults/constants';
import {
  loadApplications,
  loadOwners,
  loadExpenseTypes,
  loadImportance,
  loadStatuses,
  loadApprovers,
  loadActions,
  loadBusinessPartners,
  loadAffiliates,
  loadCustomerCompanies,
} from 'scenes/FinancialResults/sources/filters';

export const Added = (props) => (
  <Filter.DateRangePicker
    title={'Added'}
    placeholder={'All'}
    name={FILTER_ADDED}
    {...props}
  />
);

export const Period = (props) => (
  <Filter.DateRangePicker
    title={'Period'}
    placeholder={'All'}
    name={FILTER_PERIOD}
    {...props}
  />
);

export const ActionsType = (props) => (
  <Filter.Select
    title={'Show'}
    name={FILTER_ACTIONS_TYPE}
    placeholder={'All'}
    source={loadActions}
    {...props}
  />
);

export const Applications = (props) => (
  <Filter.MultiSelect
    title={'Applications'}
    placeholder={'All'}
    name={FILTER_APPLICATIONS}
    source={loadApplications}
    {...props}
  />
);

export const Approvers = (props) => (
  <Filter.MultiSelect
    title={'Approvers'}
    placeholder={'All'}
    name={FILTER_APPROVERS}
    source={loadApprovers}
    {...props}
  />
);

export const CreatedBy = (props) => (
  <UserFilter
    title={'Created by'}
    placeholder={'All'}
    name={FILTER_CREATED_BY}
    source={loadOwners}
    {...props}
  />
);

export const ExpenseTypes = (props) => (
  <Filter.MultiSelect
    title={'Expense types'}
    placeholder={'All'}
    name={FILTER_EXPENSE_TYPES}
    source={loadExpenseTypes}
    {...props}
  />
);

export const Importance = (props) => (
  <Filter.MultiSelect
    title={'Importance'}
    placeholder={'All'}
    name={FILTER_IMPORTANCE}
    source={loadImportance}
    {...props}
  />
);

export const Statuses = (props) => (
  <Filter.MultiSelect
    title={'Statuses'}
    placeholder={'All'}
    name={FILTER_STATUSES}
    source={loadStatuses}
    {...props}
  />
);

export const BusinessPartners = (props) => (
  <Filter.MultiSelect
    title={'Business partners'}
    placeholder={'All'}
    name={FILTER_BUSINESS_PARTNERS}
    source={loadBusinessPartners}
    dropdownWidth={'440px'}
    {...props}
  />
);
export const Affiliates = (props) => (
  <Filter.MultiSelect
    title={'Affiliates'}
    placeholder={'All'}
    name={FILTER_AFFILIATES}
    source={loadAffiliates}
    depends={[FILTER_BUSINESS_PARTNERS]}
    dropdownWidth={'440px'}
    {...props}
  />
);

export const CustomerCompanies = (props) => (
  <Filter.MultiSelect
    title={'Customer companies'}
    placeholder={'All'}
    name={FILTER_CUSTOMER_COMPANIES}
    source={loadCustomerCompanies}
    {...props}
  />
);
